/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */
import { useState } from 'react';
import {
  Grid,
  FormControl,
  RadioGroup,
  Typography,
  Collapse,
  Avatar,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { makeStyles } from 'tss-react/mui';

import Navigation from './Navigation';
import GreenButton from '../buttons/Green';
import Radio from '../Radio';
import { prepareOptions } from '../../shared_client_utils/formUtils';
import selectingStaffOptions from '../../shared_configs/bookingSelectingStaffOptions';
import { composeGCSUrl } from '../../shared_client_utils/googleCloudStorageUtils';

const useStyles = makeStyles()(theme => ({
  main: {
    padding: theme.spacing(2, 2, 0, 2),
    backgroundColor: '#ffffff',
    // overflowY: 'auto',
  },
  staffLine: {
    flexDirection: 'column',
    marginBottom: theme.spacing(3),
  },
  formControlLabelRoot: {
    alignItems: 'center',
    flex: 11,
  },
  checkboxLabel: {},
  staffName: {},
  staffPosition: {
    color: '#808190',
  },
  infoIconBox: {
    flex: 1,
    marginLeft: theme.spacing(2),
    alignItems: 'center',
  },
  infoIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    cursor: 'pointer',
  },
  staffInfo: {
    backgroundColor: '#F2F2F2',
    padding: theme.spacing(),
    marginTop: theme.spacing(1 / 2),
  },
  avatarBox: {
    marginRight: theme.spacing(),
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  staffBox: {
    width: 'auto',
    flexDirection: 'column',
  },
}));

const Staff = (props) => {
  const {
    stepsData,
    currentStep,
    staff: allStaff,
    business: { bookingSettings: { selectingStaffOption } },
    classes: parentClasses,
  } = props;

  const {classes, cx} = useStyles();
  const currentStepData = currentStep.getData(stepsData);

  const isNoPreferenceOptionEnabled = selectingStaffOption === selectingStaffOptions.staffOrNoPreference.option;

  const [staff, setStaff] = useState(() => ({ ...currentStepData }));
  const handleChangeStaff = ({ target: { name, value }}) => {
    const id = value;
    setStaff((prevValue) => ({
      ...prevValue,
      name,
      id,
      isNoPreference: !id,
    }));
  }

  const [expandedStaffId, setExpandedStaffId] = useState('');
  const handleChangeExpandedStaff = (staffId) => () => {
    if (expandedStaffId === staffId) {
      return setExpandedStaffId('');
    }

    setExpandedStaffId(staffId);
  }

  const handleNextStep = () => {
    if (isNoPreferenceOptionEnabled && !staff.id) {
      const areValuesChanged = staff.id !== currentStepData.id;
      const newStepData = {
        staff: {
          ...currentStepData,
          ...staff,
          isNoPreference: isNoPreferenceOptionEnabled,
        },
      };
      props.handleNextStep(newStepData, areValuesChanged);
      return;
    }

    if (!staff.id) {
      props.handleDisplayFlashMessage('Select staff', 'error');
      return;
    }

    const areValuesChanged = staff.id !== currentStepData.id;
    const newStepData = {
      staff: {
        ...currentStepData,
        ...staff,
      },
    };
    props.handleNextStep(newStepData, areValuesChanged);
  }

  const preparedStaff = prepareOptions(allStaff.byId);

  return (
    <div className={parentClasses.grid}>
      <Navigation {...props} />
      <main className={cx(parentClasses.main, classes.main)}>
        <FormControl>
          <RadioGroup
            name="staffId"
            onChange={handleChangeStaff}
            value={staff.isNoPreference ? '' : staff.id}
          >
            {isNoPreferenceOptionEnabled && (
              <Grid container className={classes.staffLine}>
                <Radio
                  name=""
                  value=""
                  component="div"
                  label={(
                    <Grid container>
                      <Typography variant="h6">No preference</Typography>
                    </Grid>
                  )}
                  className={classes.formControlLabelRoot}
                />
              </Grid>
            )}
            {preparedStaff?.map((oneStaff, i) => (
              <Grid container className={classes.staffLine} key={oneStaff.id + i}>
                <Grid container>
                  <Radio
                    key={oneStaff.id}
                    name={oneStaff.formattedFullName}
                    value={oneStaff.id}
                    component="div"
                    label={(
                      <Grid
                        container
                        className={classes.checkboxLabel}
                      >
                        {oneStaff.avatarUrl && (
                          <Grid item className={classes.avatarBox}>
                            <Avatar
                              alt={oneStaff.formattedFullName}
                              src={composeGCSUrl(oneStaff.avatarUrl)}
                              className={classes.avatar}
                            />
                          </Grid>
                        )}
                        <Grid container className={classes.staffBox}>
                          <Grid item className={classes.staffName}>
                            <Typography variant="h6">
                              {oneStaff.formattedFullName}
                            </Typography>
                          </Grid>
                          <Grid item className={classes.staffPosition}>
                            {oneStaff.position}
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    className={classes.formControlLabelRoot}
                  />
                  {oneStaff.bio && (
                    <Grid container className={classes.infoIconBox}>
                      <InfoIcon
                        onClick={handleChangeExpandedStaff(oneStaff.id)}
                        className={classes.infoIcon}
                      />
                    </Grid>
                  )}
                </Grid>
                <Collapse in={expandedStaffId === oneStaff.id}>
                  <Grid container className={classes.staffInfo}>
                    {oneStaff.bio}
                  </Grid>
                </Collapse>
              </Grid>
            ))}
          </RadioGroup>
        </FormControl>
      </main>

      <footer className={parentClasses.footer}>
        <GreenButton
          stretched
          variant="contained"
          size="large"
          onClick={handleNextStep}
          className={parentClasses.mainButton}
        >
          Next
        </GreenButton>
      </footer>
    </div>
  );
};

export default Staff;
